import { useEffect, useRef } from "react";
import Lenis from "lenis";

/**
 * Global smooth-scroll wrapper. Also broadcasts scroll to window scrollY so
 * framer-motion `useScroll` + native section anchors keep working.
 */
export default function SmoothScroll({ children }) {
    const lenisRef = useRef(null);

    useEffect(() => {
        const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        if (reduce) return;

        const lenis = new Lenis({
            duration: 1.15,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
            wheelMultiplier: 1.05,
            touchMultiplier: 1.4,
        });
        lenisRef.current = lenis;

        let rafId;
        const raf = (t) => {
            lenis.raf(t);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);

        // anchor handling: intercept in-page hash links so lenis animates them
        const onAnchor = (e) => {
            const a = e.target.closest("a[href^='#']");
            if (!a) return;
            const id = a.getAttribute("href").slice(1);
            if (!id) return;
            const el = document.getElementById(id);
            if (!el) return;
            e.preventDefault();
            lenis.scrollTo(el, { offset: -80, duration: 1.2 });
        };
        document.addEventListener("click", onAnchor);

        return () => {
            document.removeEventListener("click", onAnchor);
            cancelAnimationFrame(rafId);
            lenis.destroy();
        };
    }, []);

    return children;
}
